import { useState } from 'react';
import { Col, Row } from 'reactstrap';
import Table, { useTable } from 'common/components/table';
import TableActions from 'components/layouts/table';

import useDrawer from 'common/components/drawer/useDrawer';
import Form from './Form';
import EnumsDropdown from '../Dropdown';

const Countries = () => {
  const [active, setActive] = useState(null);

  const drawer = useDrawer();
  const table = useTable({
    label: 'nationalities',
    columns: [
      {
        header: 'Name',
        key: 'name',
        type: 'string',
        sort: true,
        width: 3
      },
      {
        header: 'Country',
        key: 'country',
        type: 'string',
        sort: true,
        canFilter: false
      }
    ]
  });

  return (
    <Row className="nationalities-table">
      <Col xs={12} className="mb-6 mt-n1">
        <TableActions
          documentTitle="Nationalities"
          title="Enums"
          dropdown={<EnumsDropdown />}
          actions={[
            { type: 'search' },
            {
              type: 'add',
              text: 'Add Nationality',
              color: 'primary',
              onClick: () => {
                setActive(null);
                drawer.open();
              }
            }
          ]}
        />
      </Col>
      <Col xs={12}>
        <Table
          loader
          drawer={<Form drawer={drawer} active={active} />}
          rows={{
            country: data => data.country?.name
          }}
          {...table}
        />
      </Col>
    </Row>
  );
};

export default Countries;
